import "./FormOverlay.scss";

export default {
  root: "im-form-overlay",
  parent: "im-form-overlay-parent",
};
